





















import Vue from "vue";
import NavigationButton from "@/components/basic/buttons/NavigationButton.vue";
import { DocumentType } from "@/constants/form-values";
import { Action } from "@/constants/ajax";
import { SET_PROGRESS, DETERMINE_STEP } from "@/constants/mutation-types";

/**
 * @deprecated
 */
export default Vue.extend({
  name: "document-selection",
  data() {
    return {
      DocumentType,
      TRANSLATION_KEY: "steps.DocumentSelection",
    };
  },
  mounted() {
    this.$store.commit(SET_PROGRESS, 7);
  },
  methods: {
    getAction(documentType: DocumentType): void {
      let action = Action.DESKTOP_DOCUMENT_SELECTION;

      if (this.$store.state.isMobile) {
        action = Action.MOBILE_DOCUMENT_SELECTION;
      }

      const data = Object.assign({}, { action, documentType });

      window.localStorage.setItem(DETERMINE_STEP, JSON.stringify(data));
    },
  },
  components: {
    NavigationButton,
  },
});
